'use strict';

(function (angular) {
    angular
        .module('jwsdw.storeDetail')
        .constant('BASE_URL', window.jwsdwSettings.baseUrl)
        .constant('IS_GOOGLE_AVAILABLE', window.google && window.google.maps);
}(angular));